import { NTDefect } from "@nt-portal/server-sdk";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputTextarea } from "primereact/inputtextarea";
import { createRef, useCallback, useEffect, useState } from "react";
import { FabrixIcon, translate } from "../../common";
import { useIcon, useModules } from "../../hooks";
import useResize from "../../hooks/use-resizer";
import { ClientNTDefectService, initializeNTDefect } from "../../services";
import { RichTextEditorRef } from "../syntax-editors/rich-text-editor";
import { ValidationInput, ValidationInputEvent } from "../validation-input";

export interface DefectDialogProps {
    open: boolean;
    onClose: () => void;
}


export function DefectDialog(props: DefectDialogProps) {
    
    const _ref = createRef<RichTextEditorRef>();
    const icon = useIcon();
    const [_open, setOpen] = useState<boolean>(false);
    const [_value, setValue] = useState<NTDefect>(initializeNTDefect());
    const modules = useModules();
    const _size = useResize("defect-dialog");

    const findModule = useCallback(()  => {
        let paths =  window.location.pathname.toLowerCase().split("/");
        let modulePath = paths.length > 1 ? paths[1] : "";
        let module = modules.find(m => m.name.toLowerCase() === modulePath);
        return module?.name ?? "";
    }, [modules])


    useEffect(() => {
        setOpen(props.open)
        if (props.open) {

            let value = { ..._value } as NTDefect;
            value.url = window.location.href;
            value.module = findModule();
            value.subTitle = `Module: ${value.module} | URL: ${value.url}`;
            

            setValue(value);
        }
    }, [props.open])

    const handleClose = () => {
        setOpen(false);
        props.onClose();
    }



    const handleSave = async () => {
        let service = new ClientNTDefectService();
        await service.add({ item: _value });
        handleClose();
    };

    const renderFooter = () => (
        <div>
            <Button label={translate("SAVE")}  icon={icon(FabrixIcon.dialogSave)} onClick={handleSave} />
            <Button label={translate("CANCEL")} icon={icon(FabrixIcon.dialogCancel)} onClick={handleClose} className="p-button-secondary" />
        </div>
    );

    const handleChange = (e: ValidationInputEvent) => {

        let id = e.originalEvent.currentTarget.id;
        let value = { ..._value }
        switch (id) {
            case "title":
                value.title = e.value;
                break;
            case "subTitle":
                value.body = e.value;
                break;
        }
        setValue(value);
    }


    const handleBodyChange = (e: any) => {
        let value = { ..._value } as NTDefect;
        value.body = e.target.value;
        setValue(value);
    }



    return (
        <Dialog id="defect-dialog" closable={true} modal={true} style={{ width: "50vw", height: "500px" }}
            header={`${translate("CORE_LOG_DEFECT")} : ${_value.module}`} visible={_open} footer={renderFooter()} onHide={() => handleClose()}>
            <div className={`grid`} >

                <div className="col-12" >
                    <ValidationInput id={"title"} value={_value.title ?? ''} caption={"CORE_DEFECT_SUBJECT"} keyName={"title"}
                        required={true} onChange={handleChange}
                    />
                </div>

                <div className="p-fluid col-12 field" >
                    <label htmlFor="tags">{translate("CORE_DEFECT_DESCRIPTION")}</label>
                    <InputTextarea id={`editor-description`} rows={4} style={{ height: _size ? _size.height - 350 : 500, resize: "none" }} className="properties-editor-item"
                        value={_value?.body} onChange={handleBodyChange} /> 

                     
                </div>
           </div>



        </Dialog>
    )
}